import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import { mobilePageConfig } from './mobilePageConfig';
import { pcPageConfig } from './pcPageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { casualPageConfig } from './casualPageConfig';

const reqParams = '/engagement/active';
const Active = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  },shallowEqual);
  const pageMap: any = {
    mobile: mobilePageConfig,
    pc: pcPageConfig,
    casual: casualPageConfig
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame] || mobilePageConfig} />
    </>
  );
};

export default Active;
